import React, { useContext } from 'react'
import styled from 'styled-components'
import { Node } from 'vendor/slate'
import { useSlate, ReactEditor } from 'vendor/slate-react'
import { EditorDispatch } from 'cg/components/documents/editor/slate/reducer'

const ApiTabsContentItem = ({ attributes, children, element, editor }) => {
  const { state, dispatch } = useContext(EditorDispatch) || {}
  const { activeTabs } = state || {}
  const { tabId } = element
  const path = ReactEditor.findPath(editor, element)
  const tabs = Node.has(editor, path) ? Node.parent(editor, path) : null

  const isTabActive = activeTabs ? (tabs ? activeTabs[tabs.id] === tabId : false) : tabs ? tabs.defaultActiveTab === tabId : false

  return (
    <TabContentItem {...attributes} active={isTabActive}>
      {children}
    </TabContentItem>
  )
}

export default ApiTabsContentItem

const TabContentItem = styled.div`
  display: ${props => (props.active ? 'block' : 'none')};
  background: ${props => props.theme.bgLightest};
  border: 1px solid ${props => props.theme.borderColor};
  margin-top: -1px;
  width: 100%;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  padding: 20px;
`
